import AlertTriangle from '@streamlinehq/streamlinehq/img/streamline-light/interface-essential/alerts/alert-triangle.svg';
import styled from 'styled-components';
import { BouSvgIcon } from '../../common/generic/components/bou-svg-icon';
import { getTextStyle } from '../../common/generic/content/texts/bou-text/text-style';
import { getTitleStyle } from '../../common/generic/content/texts/bou-title/title-style';
import { BouSpacingLevel, fluidHorizontalPadding, fluidVerticalPadding } from '../../common/generic/layout/bou-spacing';
import { fluidSpaceLg } from '../../common/generic/utilities/fluid/fluid';
import { E2eTestElementId } from '@upright/test-ids/dom-elements';

interface Props {
  title?: string;
  icon?: JSX.Element;
  content: JSX.Element;
}

export const ErrorWithIcon = (props: Props) => {
  return (
    <Root>
      <Main id={E2eTestElementId.ERROR_PAGE}>
        <TitleRow>
          <Icon>{props.icon || <BouSvgIcon icon={<AlertTriangle />} />}</Icon>
          <Title>{props.title || 'An error occurred'}</Title>
        </TitleRow>
        <Content>{props.content}</Content>
      </Main>
    </Root>
  );
};

const Root = styled.div`
  ${getTextStyle({ size: 'small' })}
  ${fluidHorizontalPadding(BouSpacingLevel.EXTRA_SMALL)};
  ${fluidVerticalPadding(BouSpacingLevel.SMALL)}
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`;

const Main = styled.div`
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const TitleRow = styled.div`
  ${getTitleStyle({ size: 'h3' })};
  margin-bottom: 1em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.div`
  ${fluidSpaceLg('font-size', 160)}
`;
const Title = styled.div`
  text-align: center;
  margin-top: 1em;
`;

const Content = styled.div`
  text-align: center;
  p + p {
    margin-top: 1em;
  }
  ul {
    margin-block-end: 0;
  }
`;
